export default class {
    // https://www.w3schools.com/howto/howto_js_slideshow.asp
    constructor() {
        this.slideshowIdx = 0;
        this.slideCount = document.getElementsByClassName('hero-image slides').length;
        this.init();
    }

    init() {
        if (document.getElementsByClassName('slides').length > 0) {
            this.scheduleNextSlide();
        }
    }

    nextSlide() {
        const classes = [
            // Hero images
            'hero-image slides',

            // Hero captions
            'hero-caption slides',
        ];

        classes.forEach((slidesClass) => {
            const mySlides = document.getElementsByClassName(slidesClass);
            const currentSlide = mySlides[this.slideshowIdx];
            const nextSlideshowIdx = (this.slideshowIdx + 1) % this.slideCount;
            const nextSlide = mySlides[nextSlideshowIdx];

            // Hide current slide, show next one
            currentSlide.classList.add('slides-hidden');
            nextSlide.classList.remove('slides-hidden');
        });

        // Update current slideshow index and schedule next update
        this.slideshowIdx = (this.slideshowIdx + 1) % this.slideCount;
        this.scheduleNextSlide();
    }

    scheduleNextSlide() {
        setTimeout(this.nextSlide.bind(this), 5000);
    }
}



// WEBPACK FOOTER //
// ./scripts/modules/heroSlideshow.js